import { AtsStaticTooltipParentRefEnum, DetectPlatformService } from '@alliance/shared/utils'
import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { StaticTooltipViewHelperService } from './static-tooltip-view-helper.service'
import { ACTIVE_TOOLTIP_PARENT_REF } from '../constants/constants'
import { RxStateService } from '@alliance/shared/models'

@Injectable()
export class CheckForStaticTooltipOptionGuard extends RxStateService<{ tooltipParent: AtsStaticTooltipParentRefEnum | null }> implements CanActivate {
  public constructor(private staticTooltipViewHelperService: StaticTooltipViewHelperService, private platform: DetectPlatformService, private router: Router) {
    super()
    this.initState({ tooltipParent: null })
  }

  public canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> | boolean {
    if (this.platform.isBrowser) {
      const activeTooltipParentRef = route.queryParamMap.get(ACTIVE_TOOLTIP_PARENT_REF)
      const tooltipParent = Object.values(AtsStaticTooltipParentRefEnum).find(value => value.toString() === activeTooltipParentRef) ?? null

      if (tooltipParent) {
        this.staticTooltipViewHelperService.setActiveParentRef(tooltipParent)
        this.set({ tooltipParent })
        const params = { ...route.queryParams }
        delete params[ACTIVE_TOOLTIP_PARENT_REF]
        return this.router.navigate([state.url.split('?')[0]], { queryParams: params, replaceUrl: false })
      }

      return true
    }

    return true
  }
}
